import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import './Home.scss';

export const Home = (props: any) => {
    const { instance } = useMsal();

    return (
        <div className="home">
            {/* <h1>Welcome Patient</h1>

            <AuthenticatedTemplate>
                <p>Please choose an option from the menu on the left to get started!</p>
            </AuthenticatedTemplate> */}
{/* 
            <UnauthenticatedTemplate>
                <p><a href="#" onClick={() => instance.loginRedirect()}>Sign In</a> to get started!</p>
            </UnauthenticatedTemplate> */}

            <div>
                <img style={{maxHeight: '100%', maxWidth: '100%'}} src="welcome-patient-web-app-home-banner.png" alt=""></img>
            </div>
        </div>
    );
};